import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged, switchMap} from 'rxjs/operators';

const startTime = Date.now();

export interface NtpConfig {
    enabled?: boolean;
    timeZone?: string;  // The time zone in IANA format
    serverAddress?: string;
    timeout?: number;
}

export enum MenuOrientation {
    LANDSCAPE = 'LANDSCAPE',
    PORTRAIT = 'PORTRAIT',
}

// tslint:disable:member-ordering
// tslint:disable:no-empty
export abstract class AbstractPlatform {
    protected panelEnabledChange$ = new BehaviorSubject<boolean | undefined>(undefined);

    panelEnabled$ = this.panelEnabledChange$.pipe(
        switchMap(state =>
            state !== undefined ? Promise.resolve(state) : this.getPanelEnabled(),
        ),
        distinctUntilChanged(),
    );

    getSerialNumber(): Promise<string | undefined> {
        return Promise.resolve(undefined);
    }

    getFirmwareVersion(): Promise<string | undefined> {
        return Promise.resolve(undefined);
    }

    getModel(): string | undefined {
        return undefined;
    }

    getMacAddress(): Promise<string | undefined> {
        return Promise.resolve(undefined);
    }

    getEthernetMacAddress(): Promise<string | undefined> {
        return Promise.resolve(undefined);
    }

    getWifiMacAddress(): Promise<string | undefined> {
        return Promise.resolve(undefined);
    }

    getConnectedWifiSsid(): Promise<string | undefined> {
        return Promise.resolve(undefined);
    }

    getConnectedWifiSignalStrength(): Promise<number | undefined> {  // 0..100
        return Promise.resolve(undefined);
    }

    getIpAddress(): Promise<string | undefined> {
        return Promise.resolve(undefined);
    }

    // TODO netmask, gateway, dns

    getAppUpdateUrl(): string | undefined {
        return undefined;
    }

    getAppUptime(): number {
        return Date.now() - startTime;
    }

    getInternalStorageAvailableCapacity(): Promise<number | undefined> {  // in bytes
        return Promise.resolve(undefined);
    }

    getSystemUptime(): number | undefined {  // in Milliseconds
        return undefined;
    }

    getSystemUptimeSeconds(): number | undefined {
        const uptimeMillis = this.getSystemUptime();
        return uptimeMillis !== undefined ? uptimeMillis / 1000 : undefined;
    }

    getCpuLoad(): Promise<number | undefined> {  // 0..1
        return Promise.resolve(undefined);
    }

    getCurrentTemperature(): Promise<number | undefined> {
        return Promise.resolve(undefined);
    }

    getPanelEnabled(): Promise<boolean | undefined> {
        return Promise.resolve(this.panelEnabledChange$.value);
    }

    setPanelEnabled(enabled: boolean): Promise<void> {
        this.panelEnabledChange$.next(enabled);
        return Promise.resolve();
    }

    getIREnabled(): Promise<boolean | undefined> {
        return Promise.resolve(undefined);
    }

    setIREnabled(_enabled: boolean): Promise<void> {
        return Promise.resolve();
    }

    getPowerButtonEnabled(): Promise<boolean | undefined> {
        return Promise.resolve(undefined);
    }

    setPowerButtonEnabled(_enabled: boolean): Promise<void> {
        return Promise.resolve();
    }

    captureScreen(): Promise<ArrayBuffer | undefined> {
        return Promise.resolve(undefined);
    }

    reboot(): Promise<void> {
        return Promise.resolve();
    }

    restartApp(): Promise<void> {
        return Promise.resolve();
    }

    getMenuOrientation(): Promise<MenuOrientation | undefined> {
        return Promise.resolve(undefined);
    }

    isSetMenuOrientationSupported(): boolean {
        return false;
    }

    setMenuOrientation(orientation: MenuOrientation): Promise<void> {
        return Promise.resolve();
    }

    isNtpSettingsAccessSupported(): boolean {
        return false;
    }

    getNtpConfig(): Promise<NtpConfig> {
        return Promise.resolve({});
    }

    setNtpConfig(_config: NtpConfig): Promise<void> {
        return Promise.resolve();
    }
}
